/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { Component } from "react";

class PromotionalClinicDetail extends Component {
  constructor(props) {
    super(props);
    const languageData = JSON.parse(localStorage.getItem("languageData")) || {
      global: {},
      business_insights: {},
    };
    this.state = {
      globalLang: languageData.global,
      showLoadingText: false,
      languageData: languageData.business_insights,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const returnState = {};
    if (
      nextProps.promotionalClinicDetail !== undefined &&
      nextProps.promotionalClinicDetail !== prevState.promotionalClinicDetail
    ) {
      returnState.promotionalClinicDetail = nextProps.promotionalClinicDetail;
      returnState.showLoader = false;
    }
    return returnState;
  }

  promotionalClinicBack = () => {
    this.props.promotionalClinicBack();
  };

  render() {
    const detail = this.props.promotionalClinicDetail || [];

    return (
      <div className="juvly-section setting-setion m-b-10 m-t-10">
        <div className="juvly-container memberShip-revenue p-b-20">
          <div className="juvly-title no-margin">
            {"Promotional Value Adjustments" +
              " - " +
              (this.props.promotionalClinicName || "Clinic") +
              (this.props.selectedDate
                ? " (" + this.props.selectedDate + ")"
                : "")}
            <a
              onClick={() => this.promotionalClinicBack()}
              className="pull-right crossIcon m-b-10"
            >
              <img src="/images/close.png" alt="" />
            </a>
          </div>

          {detail && detail.length > 0 && (
            <div className="mainRightActions">
              {/* Add export button here if export is supported */}
            </div>
          )}
        </div>

        <div className="table-responsive">
          <table className="table-updated juvly-table no-hover">
            <thead className="table-updated-thead">
              <tr>
                <th className="table-updated-th">Provider</th>
                <th className="table-updated-th">
                  Total Promotional Adjustments
                </th>
              </tr>
            </thead>
            <tbody className="table-updated-tbody">
              {detail && detail.length > 0 ? (
                detail.map((obj, idx) => (
                  <tr key={idx} className="table-updated-tr">
                    <td className="table-updated-td">{obj.provider}</td>
                    <td className="table-updated-td">
                      {obj.total_adjustments}
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="table-updated-tr">
                  <td
                    className="table-updated-td no-record no-float text-center"
                    colSpan={6}
                  >
                    {this.state.globalLang &&
                    this.state.globalLang.sorry_no_record_found
                      ? this.state.globalLang.sorry_no_record_found
                      : "No record found"}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default PromotionalClinicDetail;
